import { LitElement, html, css, classMap } from './-global.min.js'

class HHWishlistButton extends LitElement {
  static properties = {
    productId: {
      attribute: 'product-id',
      type: Number,
    },
    productUrl: {
      attribute: 'product-url',
    },
    variantId: {
      attribute: 'variant-id',
      type: Number,
    },
    _isSaved: {
      state: true,
    },
  }

  constructor() {
    super()

    this._isSaved = false
  }

  connectedCallback() {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(this.swymCallbackFn.bind(this))

    document.addEventListener('wishlist-item:updated', () => {
      this.swymCallbackFn(_swat)
    })
  }

  swymCallbackFn(swat) {
    swat.fetchWrtEventTypeET((products) => {
      const isInWishlist = this.isInwishlist(products)

      this._isSaved = isInWishlist
    }, 4)
  }

  isInwishlist(products) {
    const activeProductId = this.productId
    const activeVariantId = this.variantId

    return products.find(
      (p) => p.empi == activeProductId && p.epi == activeVariantId
    )
  }

  onClick(e) {
    e.preventDefault()
    const productInfo = {
      empi: this.productId,
      epi: this.variantId,
      du: `${window.location.origin}${this.productUrl}`,
      et: 4,
    }

    if (this._isSaved) {
      _swat.removeFromWishList(productInfo, (e) => {
        this._isSaved = false
        this.dispatchUpdate()
      })
    } else {
      _swat.addToWishList(productInfo, (e) => {
        this._isSaved = true
        this.dispatchUpdate()
      })
    }
  }

  dispatchUpdate() {
    this.dispatchEvent(
      new CustomEvent('wishlist-item:updated', {
        bubbles: true,
        composed: true,
      })
    )
  }

  render() {
    return html`<button
      type="button"
      @click="${this.onClick}"
      class="${classMap({ 'is-active': this._isSaved })}"
      aria-label="Add to Wishlist"
    >
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1 19a.91.91 0 0 1-.63-.25l-2.97-2.9-2.94 2.86a.9.9 0 0 1-1 .21.9.9 0 0 1-.41-.33.86.86 0 0 1-.15-.5V5.88c0-.24.1-.46.26-.62.17-.17.4-.26.64-.26h7.2c.24 0 .47.1.64.26.17.16.26.38.26.62v12.25c0 .23-.1.45-.26.61a.91.91 0 0 1-.64.26Z"
          fill="currentColor"
        />
      </svg>
    </button>`
  }

  static styles = css`
    button {
      border: none;
      background-color: transparent;
      padding: 0;
      cursor: pointer;
      color: var(--hh-color-ink, #0a0000);
      transition: color var(--hh-duration-default);
    }

    svg path {
      fill: var(--wishlist-icon-fill-color, transparent);
      stroke: var(--wishlist-icon-stroke-color, currentColor);
      stroke-width: 1px;
    }

    button:not(.is-active):hover svg path {
      fill: var(--wishlist-icon-hover-fill-color, currentColor);
      stroke: var(--wishlist-icon-hover-stroke-color, transparent);
    }

    button.is-active svg path {
      fill: var(--hh-color-brand-primary, #bf311a);
      stroke: transparent;
    }
  `
}

customElements.define('hh-wishlist-button', HHWishlistButton)
